import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Cookie-based auth: axios sends the httpOnly `access_token` cookie automatically
// on same-origin requests when withCredentials is true. No localStorage token needed.
const api = axios.create({ baseURL: API, withCredentials: true });

export default api;
